import { DesktopDatePicker } from '@mui/x-date-pickers';
import {
  createFilterOptions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  useTheme,
} from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PlatformService from '../../services/PlatformService';

interface Props {
  disabled: boolean;
  value: string;
  onChange: (event: SelectChangeEvent) => void;
}

const CommentStatusFilter: FC<Props> = ({ disabled, value, onChange }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <FormControl
      disabled={disabled}
      size="small"
      sx={{ minWidth: '284px', mt: theme.spacing(2) }}
    >
      <InputLabel id="comment-status-select-label">Status</InputLabel>
      <Select
        labelId="comment-status-select-label"
        value={value}
        onChange={onChange}
        label="Status"
      >
        <MenuItem value="">
          <em>-</em>
        </MenuItem>
        <MenuItem value="OPEN">{t('OPEN')}</MenuItem>
        <MenuItem value="APPROVAL">{t('APPROVAL')}</MenuItem>
        <MenuItem value="DONE">{t('DONE')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default CommentStatusFilter;
